import {
  STORE_SELECTED_TREK,
  UPDATE_OVERVIEW_EDITS,
  STORE_TREK_PREFERENCES,
  RESET_SELECTED_TREK,
  STORE_CHILD_TREKS,
} from '../actions/types';

const INITIALSTATE = {
  trek: null,
  preferences: [],
  childTreks: null,
};

export default (state = INITIALSTATE, action) => {
  const { trek, payload, childTreks } = action;
  switch (action.type) {
    case STORE_SELECTED_TREK:
      return { ...state, trek };
    case UPDATE_OVERVIEW_EDITS:
      return {
        ...state,
        trek: {
          ...state.trek,
          ...payload,
        },
      };
    case STORE_TREK_PREFERENCES:
      return {
        ...state,
        preferences: [...payload],
      };

    case STORE_CHILD_TREKS:
      return {
        ...state,
        childTreks,
      };

    case RESET_SELECTED_TREK:
      return INITIALSTATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/selectedTrekReducer.js